import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import {MenuItem, Divider} from '@mui/material';
import Typography from '@mui/material/Typography';
import {NestedMenuItem} from 'mui-nested-menu';
import {bool, element, func, node, object, oneOf, oneOfType} from 'prop-types';

import {REPORT_MODULES_CATEGORIES} from '../../../../../const';
import {useIsModuleVisibleOrEnabled} from '../../../../../hooks/components/report-modules/useIsModuleVisibleOrEnabled/useIsModuleVisibleOrEnabled';
import useProjects from '../../../../../hooks/providers/useProjects';
import useReport from '../../../../../hooks/providers/useReport';
import useReportModuleClickHandlerWithoutGuards from '../../../../embed/hooks/useReportModuleClickHandlerWithoutGuards/useReportModuleClickHandlerWithoutGuards';

const FormsListMenu = ({isNested, anchorEl = null, isOpen = false, onClose}) => {
  const {selectedProject: project} = useProjects();
  const handleFormClick = useReportModuleClickHandlerWithoutGuards();
  const {getReportsListForProject} = useReport();

  const reportsList = getReportsListForProject(project);
  const formsListIds = [
    ...new Set(
      reportsList
        .map(r => r.forms)
        .flat()
        .filter(f => f !== null)
    )
  ];

  const {isModuleVisible} = useIsModuleVisibleOrEnabled({
    visibilityOverride: ({module}) => {
      return (formsListIds || []).includes(module.formId);
    }
  });

  const allVisibleCategories = Object.values(REPORT_MODULES_CATEGORIES).filter(category => {
    const categoryHasVisibleModules = category.modules.some(m => isModuleVisible(m));
    return categoryHasVisibleModules;
  });

  console.log({allVisibleCategories});

  if (formsListIds.length === 0 || allVisibleCategories.length === 0) return null;

  const categories = allVisibleCategories
    .map(category => {
      const modules = (category.modules || []).filter(m => formsListIds.includes(m.formId));

      return modules.length > 0 ? {label: category.label, modules} : null;
    })
    .filter(Boolean);

  /** Group modules by their internal action category */
  const groupModulesByCategory = modules => {
    const groups = {};

    const visibleModules = modules.filter(m => isModuleVisible(m));
    visibleModules.forEach(m => {
      const key = m.category || 'default';
      if (!groups[key]) groups[key] = [];
      groups[key].push(m);
    });

    return Object.entries(groups); // [[groupName, modules[]], ...]
  };

  return (
    <NestedMenuItem
      id="project-menu-forms-list"
      anchorEl={isNested ? null : anchorEl}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
      open={isOpen}
      className="nested-menu-item"
      onClose={onClose}
      isNested={isNested}
      leftIcon={<EditCalendarOutlinedIcon fontSize="small" color="primary" />}
      label="Formulaires"
      parentMenuOpen
    >
      {categories.map(category => {
        const grouped = groupModulesByCategory(category.modules);

        return (
          <NestedMenuItem
            key={category.label}
            label={category.label}
            parentMenuOpen
            anchorOrigin={{vertical: 'center', horizontal: 'right'}}
            transformOrigin={{vertical: 'center', horizontal: 'left'}}
          >
            {grouped.map(([groupName, groupModules], index) => (
              <div key={groupName}>
                {index > 0 && <Divider width="100%" />}
                {groupModules.map(module => (
                  <MenuItem key={module.id} onClick={() => handleFormClick(module)}>
                    <Typography>{module.name}</Typography>
                  </MenuItem>
                ))}
              </div>
            ))}
          </NestedMenuItem>
        );
      })}
    </NestedMenuItem>
  );
};

FormsListMenu.propTypes = {
  isNested: bool.isRequired,
  isOpen: bool,
  anchorEl: oneOfType([object, element, node, oneOf([null])]),
  onClose: func
};

export default FormsListMenu;
